import { useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { compareValidator } from '@alf/validators';
import { InputField } from '@namespace/forms';

const RepeatPasswordField = ({ name, rules = {}, ...props }) => {
  const { watch, trigger, getValues } = useFormContext();
  const confirmPassword = watch('confirmPassword');
  const newPassword = watch('password');

  const validate = useCallback(async () => {
    await trigger([name]);
  }, [trigger, name]);

  useEffect(() => {
    const value = getValues()[name];
    if (value) {
      validate();
    }
  }, [confirmPassword, getValues, name, newPassword, validate]);

  return (
    <InputField
      inputType="password"
      name={name}
      rules={{
        ...rules,
        ...compareValidator(
          () => watch('password', null),
          'validation.confirmPassword'
        )
      }}
      {...props}
    />
  );
};

export default RepeatPasswordField;
